export interface SalesInvoiceStatusItem {
  id: string;
  invoiceStatus: string;
  user: string;
  processedDate: Date;
}
